import { H3, Anchor } from "../components/Text";

export const headerProviders = [
  {
    name: "number",
    label: "#",
    hidden: true,
  },
  {
    name: "typeDoc",
    label: "Tipo de documento",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/tipoDeDocumento/options",
    labelOption: "name",
    value: "name",
  },
  {
    name: "numberDoc",
    label: "Nro. de documento",
  },
  {
    name: "razonSocial",
    label: "Nombre/Razón social",
    validate: true,
  },
  {
    name: "streetAvenue",
    label: "Calle/Avenida",
    validate: true,
  },
  {
    name: "homeNumber",
    label: "N° de domicilio",
    validate: true,
  },
  {
    name: "zone",
    label: "Barrio/Zona",
  },
  {
    name: "country",
    label: "País",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/paises/options",
    labelOption: "name",
    value: "name",
    validate: true,
  },
  {
    name: "stateRegionProvince",
    label: "Estado/Departamento/Provincia",
    type: "subSelect",
    typeInput: "subSelect",

    fatherName: "country",
    fatherUrl: "/Dropdown/paises/options",
    urlApi: "departamentos",
    
    labelOption: "name",
    value: "name",
  },
  {
    name: "city",
    label: "Ciudad",
    type: "subSelect",
    typeInput: "subSelect",
    fatherName: "country",
    fatherUrl: "/Dropdown/paises/options",
    urlApi: "lugarEmbarque",
    labelOption: "name",
    value: "name",
    validate: true,
  },
  {
    name: "phone",
    label: "Teléfono/fax",
    validate: true,
  },
  {
    name: "webSite",
    label: "Sitio web",
  },
  {
    name: "email",
    label: "Correo electrónico",
    validate: true,
  },
];
export const headerBills = [
  {
    name: "number",
    label: "#",
    hidden: true,
  },
  {
    name: "e1Proveedor",
    label: "E1. Proveedor",
    type: "select",
    typeInput: "select",
    urlApiDynamic: (values) => {
      return `/ProcedureSheet/procedure/${values.procedureId}/providers`;
    },
    labelOption: "dataValue",
    value: "id",
  },
  {
    name: "e1_1Condicion",
    label: "E.1.1. Condición",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/e1_1Condicion/options",
    labelOption: "name",
    value: "name",
  },
  { name: "e1_2Especifique", label: "E1.2 Especifique"},
  {
    name: "e2PaisDeAdquisicion",
    label: "E2. País de adquisición",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/paises/options",
    labelOption: "name",
    value: "name",
  },
  {
    name: "e3NroDeFactura",
    label: "E3. N° de la factura",
  },
  {
    name: "e4FechaDeFactura",
    label: "E4. Fecha de la factura",
  },
  {
    name: "e5CondicionDeEntregaIncoterm",
    label: "E5. Condición de entrega (INCOTERM)",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/e5CondicionDeEntregaIncoterm/options",
    labelOption: "name",
    value: "name",
  },
  {
    name: "e5_1Especifique",
    label: "E5.1. Especifique",
  },
  {
    name: "e6LugarDeEntregaIcoterm",
    label: "E6. Lugar de entrega (INCOTERM)",
  },
  {
    name: "e7NaturalezaDeTransaccion",
    label: "E7. Naturaleza de la transacción",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/e7NaturalezaDeTransaccion/options",
    labelOption: "name",
    value: "name",
  },
  {
    name: "e7_1Especifique",
    label: "E7.1. Especifique",
  },
  {
    name: "e8MonedaDeTransaccion",
    label: "E8. Moneda de transacción",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/e8MonedaDeTransaccion/options",
    labelOption: "name",
    value: "name",
  },
  {
    name: "e9ValorTotalDeTransaccion",
    label: "E9. Valor total de transacción",
  },
  {
    name: "e10TipoDeCambioMonedaDeTransaccion",
    label: "E10. Tipo de cambio de la moneda de transacción",
  },
  {
    name: "e11DestinoDeMercancia",
    label: "E11. Destino de la Mercancía",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/e11DestinoDeMercancia/options",
    labelOption: "name",
    value: "name",
  },
  { name: "e11_1Especifique", label: "E11.1 Esqecifique" },
  {
    name: "e12FacturaSujetaADescuento",
    label: "E12. Factura sujeta a descuento",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/e12FacturaSujetaADescuento/options",
    labelOption: "name",
    value: "name",
  },
  {
    name: "e13FormaDePago",
    label: "E13. Forma de pago",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/e13FormaDePago/options",
    labelOption: "name",
    value: "name",
  },
  { name: "e13_1Especifique", label: "E13.1 Esqecifique" },
  {
    name: "e14MedioDePago",
    label: "E14. Medio de pago",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/e14MedioDePago/options",
    labelOption: "name",
    value: "name",
  },
  { name: "e14_1Especifique", label: "E14.1 Esqecifique" },
  {
    name: "e15ValorFobTotalUsd",
    label: "E15. Valor FOB total (USD)",
  },
  // { name: "e15_1Especifique", label: "Especifique " },
  { name: "e16ValorCifAduanaTotalUSD", label: "E16 Valor CIF aduana Total [USD]"},
  { name: "f1TotalNDePaginas", label: "F1. Total Nº de Paginas"},
  { name: "f2TotalNDeItems", label: "F2. Total Nº de Items"},
  { name: "f3TotalpesoNeto", label: "F3. Total Peso Neto [kg]"},
  { name: "ObservacionesGenerales", label: "Observaciones Generales"},
  // { name: "e25NivelComercial", label: "E25. Nivel comercial" },
  // { name: "e25_1Especifique", label: "E25.1 Especifique" },
];

export const headerItem = [
  {
    name: "itemNumber",
    label: "H1. N° Item",
    hidden: true,
  },
  { name: "nroDeFactura",
    label: "N° de la factura" 
  },
  {
    name: "h3subpartida",
    label: "H3. Subpartida arancelaria",
  },
  {
    name: "descripcionArancelaria",
    label: "Descripcion arancelaria",
  },
  { name: "h6unidadDeMedida",
    label: "H6. Unidad de medida" 
  },  
  {
    name: "h6_1unidadFisicaConversion",
    label: "H6.1. Unidad física conversión",
  },
  {
    name: "h7cantidadUnidadFisica",
    label: "H7. Cantidad unidad física",
  },
  {
    name: "h7_1cantidadFisicaConversion",
    label: "H7.1. Cantidad física conversión",
  },
  { name: "h9unidadComercial",
    label: "H9. Unidad comercial",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/h9UnidadComercial/options",
    labelOption: "name",
    value: "name", 
  },
  { name: "h9_1Especifique",
    label: "H9.1 Especifique" 
  },
  {
    name: "h10cantidadComercial",
    label: "H10. Cantidad comercial",
  },
  {
    name: "h11precioUnitarioUsd",
    label: "H11. Precio unitario (USD)",
  },
  { name: "h12paisDeOrigen",
    label: "H12. País de origen",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/paises/options",
    labelOption: "name",
    value: "name", 
  },
  { name: "h14acuerdoComercial", 
    label: "H14. Acuerdo comercial" },
  { name: "h15criterioDeOrigen", 
    label: "H15. Criterio de origen" },
  { name: "h16embalaje", 
    label: "H16. Embalaje",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/h16Embalaje/options",
    labelOption: "name",
    value: "name",
   },
  // { name: "cantidadDeBultos", label: "H17. Cantidad de bultos" },
  // { name: "pesoBrutoKg", label: "H18. Peso bruto (Kg)" },
  { name: "h19pesoNetoKg", 
    label: "H19. Peso neto (Kg)" 
  },
  { name: "h19_1pesoNetoKg", 
    label: "H19.1 Relacion Item Nº de bulto (s)" 
  },
  { name: "h20marca", 
    label: "H20. Marcas" 
  },
  { name: "h21estado", 
    label: "H21. Estado",
    type: "select",
    typeInput: "select",
    urlApi: "/Dropdown/h21Estado/options",
    labelOption: "name",
    value: "name",
   },
  { name: "h21_1especifique",
    label: "H21.1. Especifique" },
  // { name: "resolucionRitex", label: "H21. Resolución RITEX" },
  // { name: "codigoRitex", label: "H22. Código RITEX" },
  // { name: "cantidadRitex", label: "H23. Cantidad RITEX" },
  // {
  //   name: "declaracionPrecedente",
  //   label: "H24. Declaración precedente",
  // },
  // {
  //   name: "modalidadDeRegimenPrecedente",
  //   label: "H25. Modalidad de régimen precedente",
  // },
  // { name: "itemPrecedente", label: "H26. Ítem precedente" },
  {
    name: "i1valorDeTransaccionDeItemUsd",
    label: "I1. Valor de transacción del Item (USD)",
  },
  {
    name: "i2valorFobDelItemUsd",
    label: "I2. Valor FOB del item (USD)",
  },
  {
    name: "i3valorFobUnitarioUsd",
    label: "I3. Valor FOB unitario (USD)",
  },
  {
    name: "j1observacionesDelItem",
    label: "J1. Observaciones del item",
  },
  // {
  //   name: "especifiqueUComercial",
  //   label: "H9.1 Especifique U. Comercial",
  // },
  // {
  //   name: "relacionItemNroDeBultos",
  //   label: "H16. Relación Item-N° de bulto (s)",
  // },
  // {
  //   name: "descripcionUnidadTcf",
  //   label: "Descripción Unidad TCF",
  // },
  // {
  //   name: "cantidadTimbre",
  //   label: "Cantidad timbre",
  // },
  // {
  //   name: "cantidadRango",
  //   label: "Cantidad rango",
  // },
  // {
  //   name: "ley1391DS4579",
  //   label: "Ley1391 & DS4579",
  // },
];

export const headerMinimalDescription = [
  {
    name: "itemNumber",
    label: "# item",
    hidden: true,
  },
  { name: "codigoFormulario", label: "Codigo Formulario" },
  { name: "codigoFormulario2", label: "Codigo Formulario2" },
  { name: "proveedorFactura", label: "Proveedor - Factura" },
  { name: "codigo1", label: "Codigo 1" },
  { name: "valor1", label: "Valor 1" },
  { name: "codig2", label: "Codigo 2" },
  { name: "valor2", label: "Valor 2" },
  { name: "codigo3", label: "Codigo 3" },
  { name: "valor3", label: "Valor 3" },
  { name: "codigo4", label: "Codigo 4" },
  { name: "valor4", label: "valor 4" },
  { name: "codigo5", label: "Codigo 5" },
  { name: "valor5", label: "Valor 5" },
  { name: "codigo6", label: "Codigo 6" },
  { name: "valor6", label: "Valor 6" },
  { name: "codigo7", label: "Codigo 7" },
  { name: "valor7", label: "Valor 7" },
  { name: "codigo8", label: "Codigo 8" },
  { name: "valor8", label: "Valor 8" },
  { name: "codigo9", label: "Codigo 9" },
  { name: "valor9", label: "Valor 9" },
  { name: "codigo10", label: "Codigo 10" },
  { name: "valor10", label: "Valor 10" },
  { name: "codigo11", label: "Codigo 11" },
  { name: "valor11", label: "Valor 11" },
  { name: "codigo12", label: "Codigo 12" },
  { name: "valor12", label: "Valor 12" },
  { name: "codigo13", label: "Codigo 13" },
  { name: "valor13", label: "Valor 13" },
  { name: "codigo14", label: "Codigo 14" },
  { name: "valor14", label: "Valor 14" },
  { name: "codigo15", label: "Codigo 15" },
  { name: "valor15", label: "Valor 15" },
  { name: "codigo16", label: "Codigo 16" },
  { name: "valor16", label: "Valor 16" },
  { name: "codigo17", label: "Codigo 17" },
  { name: "valor17", label: "Valor 17" },
  { name: "codigo18", label: "Codigo 18" },
  { name: "valor18", label: "Valor 18" },
  { name: "codigo19", label: "Codigo 19" },
  { name: "valor19", label: "Valor 19" },
  { name: "codigo20", label: "Codigo 20" },
  { name: "valor20", label: "Valor 20" },
  { name: "codigo21", label: "Codigo 21" },
  { name: "valor21", label: "Valor 21" },
  { name: "codigo22", label: "Codigo 22" },
  { name: "valor22", label: "Valor 22" },
  { name: "codigo23", label: "Codigo 23" },
  { name: "valor23", label: "Valor 23" },
  { name: "codigo24", label: "Codigo 24" },
  { name: "valor24", label: "Valor 24" },
  { name: "codigo25", label: "Codigo 25" },
  { name: "valor25", label: "Valor 25" },
  { name: "codigo26", label: "Codigo 26" },
  { name: "valor26", label: "Valor 26" },
  { name: "codigo27", label: "Codigo 27" },
  { name: "valor27", label: "Valor 27" },
  { name: "codigo28", label: "Codigo 28" },
  { name: "valor28", label: "Valor 28" },
  { name: "codigo29", label: "Codigo 29" },
  { name: "valor29", label: "Valor 29" },
  { name: "codigo30", label: "Codigo 30" },
  { name: "valor30", label: "Valor 30" },
];

export function viewLinkExcel(url, openDialog) {
  function downloadFile(url, filename) {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.onload = () => {
      const blob = xhr.response;
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(objectUrl);
    };
    xhr.send();
  }
  downloadFile(url, "Reporte de archivo");
  openDialog(
    <div className="w-[300px]">
      <H3>Archivo generado</H3>
      <center>
        <Anchor className="text-[#264fbe] text-[1.4rem]" href={url} download>
          Descargar archivo
        </Anchor>
      </center>
      <br />
    </div>
  );
}
